export function getCurrentDate(state) {
  return state.currentDate;
}

export function getMonitoringHistories(state) {
  return state.monitoringHistories;
}



// WEBPACK FOOTER //
// ./src/app/video-lecture/store/getters.js